import type { FC } from "react";
import { MouseEvent } from "react";

import { t } from "i18n/i18n";
import { EditReferenceKeys } from "i18n/i18next";
import { Button, type ButtonProps } from "mds/components/Button";
import { PencilEditIcon } from "mds/icons";

export interface EditIconButtonProps {
  onClick: () => void;
  reference: EditReferenceKeys;
  eventPrefix?: string;
  size?: ButtonProps<"button">["size"];
}

export const ToolbarEditIconButton: FC<EditIconButtonProps> = ({
  onClick,
  reference,
  eventPrefix,
  size = "s",
}) => {
  return (
    <Button
      className="border-0 bg-[inherit] p-2 text-black-tint-20 hover:bg-black-tint-93 hover:text-black-tint-20 group-data-[selected]/listitem:text-white group-data-[unreleased]/listitem:text-black-tint-55 hover:group-data-[selected]/listitem:text-black-tint-20"
      eventName={eventPrefix ? `${eventPrefix}Rename` : undefined}
      kind="squareLegacy"
      size={size}
      title={t("edit_delete_widget.edit", { context: reference })}
      isSquare
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <PencilEditIcon />
    </Button>
  );
};
